import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { ApiPropertyValuationValuationBlockStructureTypeConstants } from "../../../../../../../shared/constants/api-constants/api-property-valuation-valuation-block-structure-type.constants";
let ValuationBlockStructureTypesService = class ValuationBlockStructureTypesService {
    httpClient;
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getPropertyValuationValuationBlockStructureTypes(params) {
        return this.httpClient.get(ApiPropertyValuationValuationBlockStructureTypeConstants.URL, { params })
            .pipe(map(response => {
            return response.value;
        }));
    }
    addPropertyValuationValuationBlockStructureType(params) {
        return this.httpClient.post(`${ApiPropertyValuationValuationBlockStructureTypeConstants.URL}`, params)
            .pipe(map(response => {
            return response;
        }));
    }
    patchPropertyValuationValuationBlockStructureType(valuationBlockStructureType, structureTypeId) {
        return this.httpClient.patch(`${ApiPropertyValuationValuationBlockStructureTypeConstants.URL}/${structureTypeId}`, valuationBlockStructureType)
            .pipe(map(response => {
            return response;
        }));
    }
    deletePropertyValuationValuationBlockStructureType(requestBody) {
        return this.httpClient.post(`${ApiPropertyValuationValuationBlockStructureTypeConstants.URL}/${ApiPropertyValuationValuationBlockStructureTypeConstants.FUNCTION_DELETE_MULTIPLE_PROPERTY_VALUATION_BLOCK_STRUCTURE_TYPES}`, requestBody)
            .pipe(map(response => {
            return response;
        }));
    }
    inheritStructureTypesFromRun(valuationBlockId) {
        return this.httpClient.post(`${ApiPropertyValuationValuationBlockStructureTypeConstants.URL}/${valuationBlockId}/InheritStructureTypesFromRun`, {})
            .pipe(map(response => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
ValuationBlockStructureTypesService = __decorate([
    Injectable({
        providedIn: "root"
    })
], ValuationBlockStructureTypesService);
export { ValuationBlockStructureTypesService };
